import { useStyles } from "./styles"
import { Box } from "@mui/material"
import React, { useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";

const FileViewerPage = () => {
    const styles = useStyles()
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);

    const type = searchParams.get('type') || '';
    const urlParam = searchParams.get('url') || '';

    const [decodedUrl, setDecodeUrl] = useState(decodeURIComponent(urlParam));
    const isVideo = ['mp4', 'wma'].includes(type)
    const isImage = ['png', 'jpg', 'jpeg'].includes(type)
    const isDocument = ['pdf', 'txt', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'].includes(type)


    useEffect(() => {

        if (['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'].includes(type)) {
            setDecodeUrl(`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(decodedUrl)}`)
        }

        if (['pdf', 'txt'].includes(type)) {
            setDecodeUrl(`https://docs.google.com/viewer?url=${encodeURIComponent(decodedUrl)}&embedded=true`)
        }

        // deshabilitar click derecho
        const disableContextMenu = (e: MouseEvent) => e.preventDefault();
        window.addEventListener('contextmenu', disableContextMenu);

        // deshabilitar F12 y Ctrl+Shift+I, Ctrl+Shift+J
        const disableDevTools = (e: KeyboardEvent) => {
            if (
                e.key === "F12" ||
                (e.ctrlKey && e.shiftKey && (e.key === "I" || e.key === "i" || e.key === "J" || e.key === "j")) ||
                (e.ctrlKey && e.key === "u") // Ctrl+U para ver código fuente
            ) {
                e.preventDefault();
            }
        };
        window.addEventListener('keydown', disableDevTools);

        return () => {
            window.removeEventListener('contextmenu', disableContextMenu);
            window.removeEventListener('keydown', disableDevTools);
        };

    }, [])

    return (
        <Box sx={styles.mainContainer}>
            <Box sx={{ width: "100vw", height: '100vh' }}>
                <Box sx={styles.container(isDocument)}>
                    {
                        isVideo && (
                            <video
                                controls
                                onContextMenu={(e) => e.preventDefault()}
                                controlsList="nodownload noremoteplayback"
                            >
                                <source src={decodedUrl} type="video/mp4" />
                            </video>
                        )
                    }

                    {
                        isImage && (
                            <img src={decodedUrl} alt="" />
                        )
                    }

                    {isDocument && (
                        <iframe
                            src={decodedUrl}
                            style={{
                                width: "100%",
                                height: "100%",
                                border: "none",
                            }}
                            title="document-viewer"
                        />
                    )}
                </Box>
            </Box>
        </Box>
    )
}

export default FileViewerPage;